"use client";

import { useEffect } from "react";
import { PREFERENCES_STORAGE_KEY, LEGACY_THEME_STORAGE_KEY, usePreferencesStore } from "@/stores/preferences-store";
import { useAuthStore } from "@/stores/auth-store";

export function ClientStoreBootstrap() {
  useEffect(() => {
    let active = true;

    void (async () => {
      const hasPreferences = window.localStorage.getItem(PREFERENCES_STORAGE_KEY) !== null;
      await usePreferencesStore.persist.rehydrate();
      if (!active) return;

      if (!hasPreferences) {
        const legacyTheme = window.localStorage.getItem(LEGACY_THEME_STORAGE_KEY);
        if (legacyTheme === "light" || legacyTheme === "dark") {
          usePreferencesStore.getState().setTheme(legacyTheme);
          window.localStorage.removeItem(LEGACY_THEME_STORAGE_KEY);
        }
      }
    })();

    void useAuthStore.getState().initialize();

    return () => {
      active = false;
    };
  }, []);

  return null;
}
